<template>
    <div class="input__radio" :style="customStyle">
     <div class="lable-text-gifting">
        <input
            :id="`${_uid}-radio`"
            class="input__radio-item"
            type="radio"
            :value="option"
            v-model="val">
        <label class="input__radio-label" :class="{'lable-height' : subLable}"
               :for="`${_uid}-radio`"
               v-html="getLabel"/>
            <p class="subtext" v-if="subLable" v-html="subLable"/>
        </div>
         <p v-if="price" class="price-text"> <b> {{currency}}{{price}} per box</b></p>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'RadioField',
    props: {
        label: {
            required: true,
            type: String,
        },
        subLable: {
            required: false,
            type: String,
        },
        option: {
            type: String,
            required: true,
        },
        value: {
            required: true,
        },
        defaultText: {
            type: String,
        },
        isCurrentPlan: {
            type: Boolean,
        },
        price: {
            type: String,
            require: false,
        },
        customStyle: {
            type: Object,
            default: () => {},
        },
    },
    data: function() {
        return {
            val: null,
        };
    },
    computed: {
        ...mapGetters({
            currency: 'localisation/getCurrency',
        }),
        getLabel() {
            return this.isCurrentPlan ? `${this.label} ${this.defaultText}` : this.label;
        },
    },
    watch: {
        val(value) {
            this.$emit('input', value);
        },
        value: {
            immediate: true,
            handler(value) {
                this.val = value;
            },
        },
    },
};
</script>

<style scoped>
.subtext {
    font-size: 14px;
    margin-left: 30px;
}
@media (min-width: 768px) {
    .subtext {
        margin-left: 8px;
        margin-top: 19px;
    }
}
.lable-text-gifting {
    display: flex;
    flex-direction: row;
}
.price-text {
    margin-top: 23px;
}
.lable-height {
    padding-top: 19px;
}
@media (max-width: 1024px) {
    .lable-text-gifting {
        flex-direction: column;
    }
    .lable-height {
        padding-top: 3px;
    }
}
@media (max-width: 468px) {
    .lable-text-gifting {
        flex-direction: column;
        margin-left: -25px;
    }
    .lable-height {
        padding-top: 6px;
    }
}
</style>
